import React, { Component } from "react";
import SortFilterButton from "../filters/SortFilterButton";
import EarningsFiltersModal from "./EarningsFiltersModal";
import EarningsSortModal from "./EarningsSortModal";
import PropTypes from "prop-types";
export default class EarningsFiltersMobile extends Component {
  state = {
    showFilterModal: false,
    showSortModal: false
  };

  toggleFilterModal = showFilterModal => {
    this.setState({ showFilterModal });
  };

  toggleSortModal = showSortModal => {
    this.setState({ showSortModal });
  };

  render() {
    const {
      options = {},
      selectedOptions = {},
      makeOnSelect = () => undefined,
      makeSelectAll = () => undefined,
      sortOrder = {},
      editSortOrder,
      clearAll,
      filterCount,
      Id
    } = this.props;
    const { showFilterModal, showSortModal } = this.state;
    return (
      <div className="hidden-lg hidden-md">
        <SortFilterButton
          sortHandler={() => this.toggleSortModal(true)}
          filterHandler={() => this.toggleFilterModal(true)}
          filterCount={filterCount}
          Id={Id}
        />
        <EarningsFiltersModal
          show={showFilterModal}
          closePanel={() => this.toggleFilterModal(false)}
          options={options}
          selectedOptions={selectedOptions}
          makeOnSelect={makeOnSelect}
          makeSelectAll={makeSelectAll}
          clearAll={clearAll}
          Id={Id}
        />
        <EarningsSortModal
          show={showSortModal}
          closePanel={() => this.toggleSortModal(false)}
          editSortOrder={editSortOrder}
          sortOrder={sortOrder}
          Id={Id}
        />
      </div>
    );
  }
}
EarningsFiltersMobile.propTypes = {
  options: PropTypes.object,
  selectedOptions: PropTypes.object,
  makeOnSelect: PropTypes.func,
  makeSelectAll: PropTypes.func,
  sortOrder: PropTypes.object,
  editSortOrder: PropTypes.func,
  clearAll: PropTypes.func,
  filterCount: PropTypes.number
};
EarningsFiltersMobile.defaultProps = {
  options: {},
  selectedOptions: {},
  makeOnSelect: () => undefined,
  makeSelectAll: () => undefined,
  sortOrder: {}
};
